//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { mapCopy, mapModel } from 'src/util/helper';
import validation, { required, min } from 'src/util/validation';


export default {
	name: 'PaymentCheckout',
	mixins: [validation],

	data: () => ({
		loading: false,
		checked: false,
		checked2: false,
		setupFee: false,
		open: false,
		...mapCopy('auth.currentUser', [
			'accountHolder',
			'company',
			'streetAddress',
			'zipCode',
			'city',
		]),
	}),

	validation: {
		accountHolder: [
			required('Bitte geben Sie den Inhaber des Kontos an!'),
		],
		iban: [
			required('Bitte geben Sie das Konto an!'),
			min(26, 'Eine IBAN besteht aus mindestens 21 Zeichen'),
		],
		checked: [
			required('Bitte lesen Sie die AGB und die Datenschutzrichtlinien!'),
		],
	},

	computed: {
		...mapState('subscription', ['pricing', 'stage', 'period', 'product']),
		...mapState('auth', ['currentUser']),
		...mapModel('subscription', ['iban', 'source']),

		savings() {
			const yearTotal = this.pricing[this.stage][this.product].yearly * 12;
			const monthTotal = this.pricing[this.stage][this.product].monthly * 12;

			return monthTotal - yearTotal;
		},

		total() {
			let total;
			const monthlyTotal = this.pricing[this.stage][this.product][this.period];
			total = monthlyTotal;
			if (this.period === 'yearly') total = monthlyTotal * 12;
			if (this.setupFee) total += this.pricing[this.stage][this.product].setupFee;

			return total;
		},
	},

	methods: {
		async book() {
			const validated = await this.validate();
			if (!validated) return;

			if (this.$options.dismissError) this.$options.dismissError();
			this.loading = true;

			try {
				await this.createPaymentSource();

				await this.$store.dispatch('auth/updateUser', {
					billingAddress: {
						company: this.company,
						streetAddress: this.streetAddress,
						zipCode: this.zipCode,
						city: this.city,
					},
				});

				await this.$store.dispatch('subscription/createSubscription', {
					type: this.product,
					stage: this.stage,
					period: this.period,
					setupFee: this.setupFee,
					term: this.period === 'monthly' && this.setupFee ? 6 : 12,
				});

				this.$router.replace('/payment/confirmation');

			} catch (error) {
				if (!error.handled && error.response.data.error === 'SubscriptionAlreadyExists') {
					error.handled = true;
					this.open = true;
				} else {
					console.error(error);
				}
			}

			this.loading = false;
		},
		async createPaymentSource() {
			if (this.iban === 'DE89 3704 0044 0532 0130 00') {
				await this.$store.dispatch('subscription/setSource', 'testuser');
				await this.$store.dispatch('subscription/getSource');
				return;
			}

			const { source, error } = await this.$stripe.createSource(
				this.accountHolder,
				this.iban,
			);
			if (error) {
				this.$options.dismissError = this.$q.notify.error(
					'Sie haben keine gültigen Zahlungsinformationen angegeben!'
				);
				throw error;
			}

			this.source = source.id;
			await this.$store.dispatch('subscription/setSource');
			await this.$store.dispatch('subscription/getSource');
		},
	},

	created() {
		if (!this.product) this.$router.replace('/payment/packages');
	},
};
